<template>
  <div class="sp-checkout__review-section">
    <sp-row align="center" no-gutters>
      <sp-icon
        v-if="icon"
        class="sp-checkout__review-section-title-icon"
        :name="icon"
        fill-color="var(--sp-sys-color-primary)"
      ></sp-icon>
      <sp-title v-if="title" class="sp-checkout__review-section-title">{{ title }}</sp-title>
    </sp-row>
    <sp-divider></sp-divider>

    <sp-row :no-gutters="contentRowNoGutters">
      <slot />
    </sp-row>

    <slot name="footer" />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { booleanAttribute, toBoolean } from "#ce/utils/props";

const props = defineProps({
  title: {
    type: String,
    default: undefined,
  },
  icon: {
    type: String,
    default: undefined,
  },
  /**
   * When true, the default-slot row omits horizontal gutter margins (needed for full-width form
   * markup inside BasePanel, whose content uses overflow-x: hidden).
   */
  contentNoGutters: booleanAttribute(),
});

const contentRowNoGutters = computed(() => toBoolean(props.contentNoGutters));
</script>

<style lang="scss" scoped>
.sp-checkout__review-section {
  margin-bottom: 3rem;

  sp-divider {
    margin-top: var(--sp-ref-spacing-4);
    margin-bottom: var(--sp-ref-spacing-12);
  }
}
.sp-checkout__review-section-title-icon {
  margin-right: var(--sp-ref-spacing-5);
  transform: translateY(
    calc(var(--sp-ref-spacing-px) * -1)
  ); // offset the icon to align with the title TODO: find a better way to do this
}

.sp-checkout__review-section-title {
  text-transform: var(--sp-comp-checkout-review-section-title-text-transform);
}
</style>
